import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useContextHook } from "../../Context/ContextOPen";
import {
  AboutUs,
  ContactUs,
  Features,
  Hero,
  Projects,
  Services,
} from "../../components";
import "./style.css";
import { useEffect } from "react";

export default function Home() {
  const { setSwiperIndex } = useContextHook();
  const SwiperSlideData = [
    { name: Hero, id: 0 },
    { name: AboutUs, id: 1 },
    { name: Services, id: 2 },
    { name: Features, id: 3 },
    { name: Projects, id: 4 },
    { name: ContactUs, id: 5 },
  ];
  return (
    <div className="max-lg:hidden h-[91dvh]">
      <Swiper
        zoom
        direction="vertical"
        speed={1000}
        slidesPerView={1}
        spaceBetween={10}
        mousewheel={true}
        modules={[Mousewheel, Pagination]}
        onSlideChange={(swiper) => setSwiperIndex(swiper.activeIndex)}
      >
        {SwiperSlideData.map((e, index) => (
          <SwiperSlide id={e.name} key={index} className="overflow-hidden">
            <e.name />
          </SwiperSlide>
        ))}
        <SlideNextButton />
      </Swiper>
    </div>
  );
}
const SlideNextButton = ({ index }) => {
  const { swiperIndex } = useContextHook();
  const swiper = useSwiper();
  useEffect(() => {
    if (swiperIndex || swiperIndex === 0) {
      swiper?.slideTo(swiperIndex);
    }
  }, [swiperIndex]);

  return <div className="icons "></div>;
};
